<template>
  <div>
    <v-snackbar v-model="showError" :timeout="timeout" color="red">
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="showError = false">
          Close
        </v-btn>
      </template>
      <p v-for="(error, index) of errors" :key="index">
        {{ error }}
      </p>
    </v-snackbar>
    <v-overlay z-index="10000" :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-form>
      <v-row>
        <v-col>
          <v-data-table
            :headers="consumersHeaders"
            :items="filteredConsumers"
            :search="search"
          >
            <template v-slot:top>
              <v-row>
                <v-col cols="2">
                  <v-select
                    :items="apis"
                    label="Select an api"
                    v-model="api"
                    clearable
                  >
                    <template v-slot:item="{ item }"
                      ><span>{{ item }}</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-select
                    :items="environments"
                    label="Select an environment"
                    v-model="environment"
                    clearable
                  >
                    <template v-slot:item="{ item }"
                      ><span>{{ item }}</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-select
                    :items="statuses"
                    label="Select a status"
                    v-model="status"
                    clearable
                  >
                    <template v-slot:item="{ item }"
                    ><span>{{ item }}</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="search"
                    label="Search"
                    class="mx-4"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.clientIds="{ item }">
              <v-list dense>
                <v-list-item v-for="(clientId, i) in item.clientIds" :key="i">
                  {{ clientId }}
                </v-list-item>
              </v-list>
            </template>
            <template v-slot:item.subKeyArray="{ item }">
              <v-list dense>
                <v-list-item v-for="(subKey, i) in item.subKeyArray" :key="i">
                  {{ subKey }}
                </v-list-item>
              </v-list>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('consumers');
export default {
  name: 'Consumers',
  computed: {
    ...mapState([
      'loading',
      'errors',
      'consumers',
      'apis',
      'environments',
      'statuses'
    ]),
    filteredConsumers() {
      if (!this.consumers) return [];
      return this.consumers
        .filter(c => !this.status || c.status === this.status)
        .filter(c => !this.api || c.api === this.api)
        .filter(c => !this.environment || c.environment === this.environment)
        .map(c => {
          const subKeyArray = c.subKeys?Object.values(c.subKeys):[];
          return { ...c, subKeyArray };
        });
    }
  },
  data() {
    return {
      search: '',
      timeout: 3000,
      showError: false,
      consumersHeaders: [
        { text: 'Api', value: 'api', filterable: false },
        { text: 'Environment', value: 'environment', filterable: false },
        { text: 'Product', value: 'product' },
        { text: 'Client ids', value: 'clientIds' },
        {
          text: 'Sub keys',
          value: 'subKeyArray',
          filterable: true,
          visible: false
        },
        { text: 'Status', value: 'status' }
      ],
      api: null,
      environment: null,
      status: null
    };
  },
  watch: {
    errors(newValue) {
      this.showError = newValue.length > 0;
    }
  },
  async created() {
    await this.initConsumers();
  },
  methods: {
    ...mapActions(['initConsumers'])
  }
};
</script>

<style></style>
